import React, { useEffect, useState } from "react";
import BookingBusItem from "./BookingBusItem";
import {
  getBookingSearchFormatedDateValue,
  getBookingFormatedValue,
  getTimeDifference,
} from "../../utils/Functions";
import { useNavigate } from "react-router-dom";
import { useBoardingDropping } from "../../context/BoardingDroppingContext";
import { getCategoryByData } from "../../utils/api.functions";
import Loader from "../loader";
import { CITY_ID } from "../../utils/common.data";
import './style.css'

const BookingPage = ({handleView}) => {
  const [viewSeatId, setViewSeatId] = useState(null);
  const navigate = useNavigate();
  const [searchDetail, setSearchDetail] = useState({
    boarding: "",
    dropping: "",
    travel_date: "",
  });
  const [isLoading, setIsLoading] = useState(true);
  const [category, setCategory] = useState([]);
  const [view, setView] = useState(0)

  const { boardingDroppingPoints, fetchBoardingDroppingPoints,categoryTags,fetchCategoryTagsList } =
    useBoardingDropping();

  useEffect(() => {
    if (!boardingDroppingPoints) {
      fetchBoardingDroppingPoints(); // Fetch data if not already available
    }
  }, [boardingDroppingPoints, fetchBoardingDroppingPoints]);
  
    useEffect(() => {
      if (!categoryTags) {
        fetchCategoryTagsList(); // Fetch data if not already available
      }
    }, [categoryTags, fetchCategoryTagsList]);

  useEffect(() => {
    const searchData = sessionStorage.getItem("bookingdetails");
    if (searchData) {
      try {
        const searchValue = JSON.parse(searchData);
        setSearchDetail({
          ...searchDetail,
          ...searchValue,
          travel_date: searchValue?.date,
        });
        fetchCategories(searchValue);
      } catch (error) {
        console.log(`search Data Err`, error);
        navigate("/booknow");
      }
    } else {
      navigate("/booknow");
    }
  }, []);

  useEffect(() => {
    let username = sessionStorage.getItem("auth");
    if (username === "" || username === null) {
      navigate("/login");
    }
  }, []);

  const handleCategoryData = (val, category) => {
    if(category) return val?.filter((value)=> value.category_id == category)
    return val.sort((a, b) => {
      return new Date(a.departure) - new Date(b.departure);
    });
  };

  const handleCategoryViewCab = (val, category) => {
    return val?.filter((value)=> value.category_id !== category)
  };

  const handleCloseViewCab = () => {
    setViewSeatId(null)
  }

  const fetchCategories = async (value) => {
    const apiKey = sessionStorage.getItem("key");
    try {
      const response = await getCategoryByData({ ...value, city_id: CITY_ID }, apiKey);
      ////console.log({ response });

      if (response.status === 200) {
        const newData = response?.data?.resDecrypt?.response;

        // Check if the category data already exists
        if (newData && newData.length > 0) {
          // Assuming the data has a unique identifier like category_id
          const newCategoryIds = newData.map(item => item.category_id);

          setCategory((prevCategories) => {
            // Filter out existing categories that already exist in newData
            const filteredPrevCategories = prevCategories?.filter(
              (item) => !newCategoryIds.includes(item.category_id)
            );

            // Merge the previous categories and new data
            const updatedCategories = [...filteredPrevCategories, ...newData];

            setIsLoading(false); // Disable loading once data is fetched
            return updatedCategories; // Return the merged data
          });
        } else {
          setIsLoading(false); // Disable loading if no data
        }
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      console.log("Category Error", error);
      setIsLoading(false); // Disable loading in case of an error
    }
  };


  const handleSeatArrayData = (cat_max_size, seat_price, seatBooked) => {
    const seatBookedValue = seatBooked || []
    const value = Array(parseInt(cat_max_size))
      .fill()
      .map((value, index) => {
        return {
          id: `c${index + 1}`,
          seat_id: index + 1,
          available: !seatBookedValue.includes(index + 1),
          normal: parseFloat(seat_price?.normal),
          window: parseFloat(seat_price?.window)
        };
      });
    return value;
  };

  const handleViewChange = (val) => {
    if(handleView){
      handleView()
      return
    }
    ////setView(val)
    navigate('/booknow') 
  }

  return (
    <div className="main_booking_page_container st_slider_index_sidebar_main_wrapper st_slider_index_sidebar_main_wrapper_booking">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            {view === 0 ? <div className="search_data_main">
              <div className="search_data_main_board">
                {searchDetail?.boarding}
              </div>
              <div className="search_data_main_arrow">
                <i className="fas fa-arrow-right"></i>
              </div>
              <div className="search_data_main_depart">
                {searchDetail?.dropping}
              </div>
              <div className="search_data_main_time">
                {getBookingSearchFormatedDateValue(new Date(searchDetail?.travel_date))}
              </div>
              <div className="search_data_main_button">
                <button className="common_button_border" type="button" onClick={() => { handleViewChange('/booknow') }}>Change</button>
              </div>
            </div> : <></>}
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="st_indx_slider_main_container">
              {isLoading && <Loader />}
              {!isLoading && category && category?.length == 0 && (
                <div className="no_data_found">
                  <h3>No ride for this day</h3>
                </div>
              )}
              {category && category?.length > 0 && (
                <div className="tab-content">
                  <div id="home" className="tab-pane active">
                    <div className="booking_card_header">
                      <div className="w_30 fl" style={{ display: "flex" }}>
                        <span className="w_60 d-block d-found">
                          <span className="f-bold busFound"> </span>
                        </span>
                        <span className="w_30 d-block f_12 header_color f-bold t-right"></span>
                      </div>
                      <div className="w_20 fl f_14 header_color">
                        <span>Departure</span>
                      </div>
                      <div className="w_10 fl f_14 header_color">
                        <span>Duration</span>
                      </div>
                      <div className="w_20 fl f_14 header_color">
                        <span>Arrival</span>
                      </div>
                      {/* <div className="w_10 fl f_14 header_color">
                        <span>Ratings</span>
                      </div> */}
                      <div className="w_10 fl f_14 header_color">
                        <span>Fare</span>
                      </div>
                      <div className="w_10 fl f_14 header_color">
                        <span>Seats Available</span>
                      </div>
                    </div>
                    <div className="booking_card_item_list">
                      {handleCategoryData(category, viewSeatId).map((categoryItem) => (
                        <BookingBusItem
                          busValue={{
                            ...categoryItem,
                            seats: handleSeatArrayData(categoryItem?.cat_max_size, categoryItem?.seat_price, categoryItem?.bookedSeat),
                          }}
                          key={categoryItem?.category_id}
                          id={categoryItem?.category_id}
                          name={categoryItem?.cat_name}
                          images={categoryItem?.cat_icon_path}
                          price={categoryItem?.price}
                          departure={getBookingFormatedValue(
                            new Date(categoryItem?.departure)
                          )}
                          arrival={getBookingFormatedValue(
                            new Date(categoryItem?.arrival)
                          )}
                          duration={getTimeDifference(
                            new Date(categoryItem?.departure),
                            new Date(categoryItem?.arrival)
                          )}
                          rating={categoryItem?.driver?.d_rating}
                          ratingCount={categoryItem?.driver?.d_rating_count}
                          seatsAvailable={categoryItem?.seatsAvailable}
                          fetchCategories={() => {
                            fetchCategories({
                              category_id: categoryItem?.category_id,
                              date: searchDetail.travel_date,
                            });
                          }}
                          viewSeatId={viewSeatId} // Pass the state
                          setViewSeatId={setViewSeatId} // Pass the setter
                          categoryTags={categoryTags}
                        />
                      ))}
                    </div>
                    {viewSeatId && handleCategoryViewCab(category, viewSeatId).length > 0 && <div className="booking_card_item_list_count">
                      <div onClick={() => {handleCloseViewCab()}}><span>{handleCategoryViewCab(category, viewSeatId).length}</span>
                      <span>Rides</span>{" "}
                      <i
                              className="fas fa-chevron-down"
                              aria-hidden="true"
                            ></i>  </div>                    </div>}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingPage;
